"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCheckerBoardBackground = createCheckerBoardBackground;
function createCheckerBoardBackground() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$darkColor = options.darkColor,
    darkColor = _options$darkColor === void 0 ? 'rgba(0,0,0,0.15)' : _options$darkColor,
    _options$lightColor = options.lightColor,
    lightColor = _options$lightColor === void 0 ? 'transparent' : _options$lightColor,
    _options$size = options.size,
    size = _options$size === void 0 ? 24 : _options$size;
  var position = size / 2;
  return {
    backgroundImage: ["linear-gradient(45deg, ".concat(darkColor, " 25%, ").concat(lightColor, " 25%)"), "linear-gradient(-45deg, ".concat(darkColor, " 25%, ").concat(lightColor, " 25%)"), "linear-gradient(45deg, ".concat(lightColor, " 75%, ").concat(darkColor, " 75%)"), "linear-gradient(-45deg, ".concat(lightColor, " 75%, ").concat(darkColor, " 75%)")].join(', '),
    backgroundSize: "".concat(size, "px ").concat(size, "px"),
    backgroundPosition: "0 0, 0 ".concat(position, "px, ").concat(position, "px -").concat(position, "px, -").concat(position, "px 0px")
  };
}